// extracted by mini-css-extract-plugin
export default {"modalHeader":"iba-z","modalContent":"jba-z","formWrapper":"kba-z","fade":"lba-z","fade-in":"mba-z"};